// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"c2-z","dimensionLabel":"d2-z","styleChooserControlWrapper":"e2-z","styleChooserControl":"f2-z","disabled":"g2-z","giftCard":"h2-z","styleChooserText":"i2-z"};